import { get, useForm } from 'react-hook-form';
import { Button } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

import { Strings } from '@app/constants';
import { FormProvider } from '@app/components';
import { IDocumentInfoSchema, IMyProfileResponse } from '../types';
import { DocumentsInfoForm } from '@app/sections/shared/document-info-form';
import { OfficialInfoForm } from '@app/sections/shared/official-info-form';
import { getEmployees } from '@app/modules/employees';
import { updateProfile } from './slice';
import { documentInformationSchema } from '../validators';

interface Props {
  row?: IMyProfileResponse;
}

const DocumentInformationPage = ({ row }: Props) => {
  const dispatch = useDispatch();
  const methods = useForm<IDocumentInfoSchema>({
    resolver: yupResolver(documentInformationSchema) as any,
    defaultValues: {
      documentInfo: {
        aadharFront: get(row, 'aadharFront', ''),
        aadharBack: get(row, 'aadharBack', ''),
        panFront: get(row, 'panFront', ''),
        panBack: get(row, 'panBack', ''),
      },
      officialInfo: {
        officialEmail: get(row, 'email', ''),
        roleId: row?.roleId,
        managerId: row?.managerId ? row.managerId.map((id) => Number(id)) : [],
        joiningDate: get(row, 'joiningDate', ''),
        department: row?.department,
        designation: row?.designation,
      },
    },
  });

  useEffect(() => {
    dispatch(getEmployees());
  }, []);

  const onSubmit = (form: IDocumentInfoSchema) => {
    dispatch(updateProfile({ documentInfo: { ...form }, id: row?.id }));
  };
  return (
    <>
      <FormProvider methods={methods} onSubmit={methods.handleSubmit(onSubmit)}>
        <DocumentsInfoForm
          data={row}
          additionalButton={
            <Button
              variant="outlined"
              color="inherit"
              size="large"
              sx={{ width: 'max-content' }}
              type="submit"
            >
              {Strings.button.saveDocumentsInformation}
            </Button>
          }
        />
        <OfficialInfoForm disabled joiningDate={row?.joiningDate} />
      </FormProvider>
    </>
  );
};
export { DocumentInformationPage };
